<template>
  <div class="grid-x grid-padding-x align-middle contentContainer">
    <div class="cell small-10 medium-7 large-7 contentPosition">
      <img class="quoteImg" src="@/assets/img/icons/quote-large-trans.png" alt="diversity quote" />
      <h1>Rare doesn’t make the process easier, it makes the candidate better.</h1>
      <span class="name">Sengova Kailondo</span>
      <span class="position hide-for-medium">asset finance lawyer at Hogan Lovells and Rare alumnus </span>
      <span class="position show-for-medium">asset finance lawyer and Rare alumnus</span>
      <img class="logoImg" src="@/assets/img/logos/home-page-logos/HoganLovells.png" alt="Hogan Lovells logo" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'RareCandidatesHeaderContents',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }


  .name {
    color: $green-highlight ;
    display: block;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .position {
    color: #ffffff;
    display: block;
    letter-spacing: 2px;
    text-transform: uppercase;
  }


  @media only screen and (max-width: 640px)  {
    .contentPosition {
      padding-left: 6%;
    }

    .name {
      font-size: 18px;
    }

    .position {
      font-size: 12px;
    }

    .quoteImg {
      margin-bottom: 10px;
      max-height: 24px;
    }

    .logoImg {
      width: 60px;
      margin-top: 10px;
    }

    h1 {
      font-size: 26px;
      line-height: 1.33;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1150px)  {
    .contentPosition {
      padding: 0 0 0 5%;
    }

    .name {
      font-size: 18px;
    }

    .position {
      font-size: 12px;
    }

    .quoteImg {
      margin-bottom: 10px;
      max-height: 36px;
    }

    .logoImg {
      display: none;
    }


    h1 {
      font-size: 48px;
      line-height: 1.25;
    }
  }

  @media only screen and (min-width: 1050px)  {
    .contentPosition {
      padding: 0 0 0 12%;
    }

    .name {
      font-size: 28px;
      margin-top: 23px;
      margin-bottom: 2px;
    }

    .position {
      font-size: 20px;
    }

    .quoteImg {
      margin-bottom: 16px;
      max-height: 48px;
    }

    .logoImg {
      margin-top: 24px;
      max-height: 74px;
    }

    h1 {
      font-size: 56px;
      line-height: 70px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesHeaderContents.vue